import { mapShopType, PojectSpendingShopType } from "./PojectSpendingShopType";

export interface ProjectSpendingDataType {
    id?: number;
    project_id?: number;
    category?: string;
    date?: string;
    shop_id?: number | null;
    // material_type?: 'Building material' | 'Client material'|null;
    material_type?: string | null;
    title?: string;
    amount?: number;
    file?: string | null;
    file_extension?: string | null;
    is_approved?: 1 | 0;
    created_by?: number;
    spending_shop?: PojectSpendingShopType | null;
}

// to single object maping
export const mapSpendingDataType = (data: any): ProjectSpendingDataType => {
    if (!data) {
        throw new Error('Invalid Data')
    }
    
    const shop: ProjectSpendingDataType = {
        id: data.id,
        project_id: data.project_id,
        category: data.category,
        date: data.date,
        shop_id: data.shop_id,
        material_type: data.material_type,
        title: data.title,
        amount: data.amount,
        file: data.file,
        file_extension: data.file_extension,
        is_approved: data.is_approved,
        created_by: data.created_by,
        spending_shop: (data.spending_shop != null) ? mapShopType(data.spending_shop) : null,
    }

    return shop;
}

// maping list objects
export const mapSpendingDataTypes = (data: any[]): ProjectSpendingDataType[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }
    return data.map(mapSpendingDataType);
}



